import { Yup, type YupTypes } from "@pharmupp/p3-front-commons"
import {
  type orderDeliveryServiceNames,
  orderDeliveryServicesConf,
} from "./referential/orderDeliveryService.referential"

export enum PatientServicesEnum {
  HAS_PRESCRIPTION_SCANNER = "hasPrescriptionScanner",
  ORDER_DELIVERY_SERVICES = "orderDeliveryServices",
  HEALTH_APPOINTMENT_URL = "healthAppointmentUrl",
}

// Type for order delivery service - explicit type instead of inferred unknown
export type OrderDeliveryService = Record<orderDeliveryServiceNames, string | null>

const orderReferential = () => {
  const shape = Object.keys(orderDeliveryServicesConf).reduce<YupTypes.ObjectShape>(
    (res, name) => {
      res[name] = Yup.boolean().nullable()
      return res
    },
    {},
  )
  return Yup.object().shape(shape)
}

export const patientServicesSchema = Yup.object({
  [PatientServicesEnum.HAS_PRESCRIPTION_SCANNER]: Yup.boolean().required(),
  [PatientServicesEnum.ORDER_DELIVERY_SERVICES]: orderReferential(),
  [PatientServicesEnum.HEALTH_APPOINTMENT_URL]: Yup.string().url().nullable(),
})

export type PatientServiceFormValues = Omit<
  YupTypes.InferType<typeof patientServicesSchema>,
  PatientServicesEnum.ORDER_DELIVERY_SERVICES
> & {
  [PatientServicesEnum.ORDER_DELIVERY_SERVICES]: OrderDeliveryService | null
}
